export const TODAY = 'TODAY';
export const YESTERDAY = 'YESTERDAY';
export const LAST_SEVEN_DAYS = 'LAST_SEVEN_DAYS';
export const THIS_MONTH = 'THIS_MONTH';
export const LAST_THREE_MONTHS = 'LAST_THREE_MONTHS';
export const LAST_SIX_MONTHS = 'LAST_SIX_MONTHS';
export const THIS_YEAR = 'THIS_YEAR';
export const LAST_YEAR = 'LAST_YEAR';
export const SINCE_START = 'SINCE_START';
export const SELF_DEFINED = 'SELF_DEFINED';
